import browserDetect from "browser-detect";

export const browser = browserDetect();

const versionNumber = browser.versionNumber ?? 9999999;

export const isBrowserSupported: boolean =
  (browser.name === "chrome" && versionNumber >= 77) ||
  (browser.name === "crios" /* Chrome on iOS */ && versionNumber >= 77) ||
  (browser.name === "firefox" && versionNumber >= 75) ||
  (browser.name === "edge" && versionNumber >= 83) ||
  (browser.name === "safari" && versionNumber >= 13);

export function getIsProduction(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return [
    "servicecentre.latitudefinancial.com",
    "servicecentre.latitudefinancial.com.au",
    "servicecentre.latitudefinancial.co.nz",
  ].includes(window.location.hostname);
}
